import { Component, OnInit, Input } from '@angular/core';
import { WorkInformation } from '@akiba/models_bimbo';

@Component({
  selector: 'app-work-information',
  templateUrl: './work-information.component.html',
  styleUrls: ['./work-information.component.scss']
})
export class WorkInformationComponent implements OnInit {

  @Input() disabled: boolean;
  @Input() workInformation: WorkInformation;
  constructor() { }

  ngOnInit() {
  }

  get employeeSeniority() {
    const t = this.workInformation.seniorityDate;
    return t;
  }

  get wageInfo(): string {
    const type = this.workInformation.wage && this.workInformation.wage.wageName ? this.workInformation.wage.wageName.charAt(0).toUpperCase() + this.workInformation.wage.wageName.toLowerCase().slice(1) : '';
    return 'Salario ' + type + ':';
  }

  get totalAmountPaid(): number {
    const amount = this.workInformation.wage ? this.periodWage : 0.00;
    return amount;
  }

  get periodWage() {
    const pt = Number(this.workInformation.wage.wageID);
    if (pt === 2 || pt === 4) {
        return this.workInformation.wage.amount * 14;
    }
    return this.workInformation.wage.amount * 7;
}

}
